import { useCookies } from "react-cookie";
import Constants from "../../utils/Constants";

// 権限CDリスト
export const useProtectedRouteAuthCd = function (authCd: string): boolean {

  const [cookies] = useCookies(["authList"]);

  // 入力値チェック
  if (checkAuthCd(authCd) || !cookies.authList) {
    return false;
  }

  // 権限チェック
  return getAuthCd(authCd);

  // 権限リストと比較
  function getAuthCd(authCd: string) : boolean {
    let authIn = false;

    let list = cookies.authList;

    list.forEach((element: string) => {
      if (element.toString() === authCd.toString()) {
        authIn = true;
      }
    });

    return authIn;
  }

  // 有効範囲チェック
  function checkAuthCd(authCd : string) {

    if (
      authCd === Constants.AUTH_TENANT ||
      authCd === Constants.AUTH_CONTRACT ||
      authCd === Constants.AUTH_CONTRACT_USER ||
      authCd === Constants.AUTH_TENANT_CREATE ||
      authCd === Constants.AUTH_TENANT_DELETE ||
      authCd === Constants.AUTH_TENANT_DETAIL ||
      authCd === Constants.AUTH_TENANT_EDIT ||
      authCd === Constants.AUTH_CONTRACT_CREATE ||
      authCd === Constants.AUTH_CONTRACT_DELETE ||
      authCd === Constants.AUTH_CONTRACT_DETAIL ||
      authCd === Constants.AUTH_CONTRACT_EDIT ||
      authCd === Constants.AUTH_CONTRACT_USER_CREATE ||
      authCd === Constants.AUTH_CONTRACT_USER_DELETE ||
      authCd === Constants.AUTH_CONTRACT_USER_DETAIL ||
      authCd === Constants.AUTH_CONTRACT_USER_EDIT ||
      authCd === Constants.AUTH_COMPANY_CREATE ||
      authCd === Constants.AUTH_COMPANY_DELETE ||
      authCd === Constants.AUTH_COMPANY_DETAIL ||
      authCd === Constants.AUTH_COMPANY_EDIT ||
      authCd === Constants.AUTH_MDM_USER_CREATE ||
      authCd === Constants.AUTH_MDM_USER_DELETE ||
      authCd === Constants.AUTH_MDM_USER_DETAIL ||
      authCd === Constants.AUTH_MDM_USER_EDIT || 
      authCd === Constants.NAVI_FORBIDDEN
    ) {
      return false;
    } else {
      return true;
    }

  }
}

export default useProtectedRouteAuthCd;
